/**
 * PRNG déterministe minimal (mulberry32) pour la logique pure de `shared/game`
 * qui a besoin d'aléatoire testable (tirage pondéré des cases du plateau,
 * lancers de dé du tour de chauffe) — même algorithme que celui utilisé en
 * spy sur `Math.random` dans les tests "Hill Valley"
 * (`server/tests/game/hillValleyRound14PrngRankingProbe.test.ts`), mais ici
 * exposé comme générateur injectable plutôt que comme mock de test.
 */
export function mulberry32(seed: number): () => number {
  let t = seed >>> 0;
  return function random(): number {
    t += 0x6d2b79f5;
    let r = t;
    r = Math.imul(r ^ (r >>> 15), r | 1);
    r ^= r + Math.imul(r ^ (r >>> 7), r | 61);
    return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
  };
}
